import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

const TOKEN_KEY = "dentium_token";
export const setAuthToken = (token) => {
  if (token) {
    api.defaults.headers.common.Authorization = `Bearer ${token}`;
    localStorage.setItem(TOKEN_KEY, token);
  } else {
    delete api.defaults.headers.common.Authorization;
    localStorage.removeItem(TOKEN_KEY);
  }
};
export const getStoredToken = () => localStorage.getItem(TOKEN_KEY);
const boot = getStoredToken();
if (boot) api.defaults.headers.common.Authorization = `Bearer ${boot}`;

export const authLogin = (email, password) =>
  api.post("/auth/login", { email, password }).then((r) => r.data);
export const authMe = () => api.get("/auth/me").then((r) => r.data);

export const getStats = () => api.get("/stats").then((r) => r.data);
export const getConversations = (channel, status) =>
  api.get("/conversations", { params: { channel, status } }).then((r) => r.data);
export const getScheduleStatus = (mode) =>
  api.get("/schedule-status", { params: { schedule_mode: mode } }).then((r) => r.data);
export const sendChat = (payload) => api.post("/chat", payload).then((r) => r.data);
export const seed = () => api.post("/seed").then((r) => r.data);
export const getNotifications = () => api.get("/notifications").then((r) => r.data);
export const markNotificationRead = (id) => api.post(`/notifications/${id}/read`).then((r) => r.data);
export const markAllNotificationsRead = () => api.post("/notifications/read-all").then((r) => r.data);
export const attendConversation = (id) => api.post(`/conversations/${id}/attend`).then((r) => r.data);
export const getAppointmentReminder = () => api.get("/appointment-reminder").then((r) => r.data);
export const reopenConversation = (id) => api.post(`/conversations/${id}/reopen`).then((r) => r.data);
export const deleteConversation = (id) => api.delete(`/conversations/${id}`).then((r) => r.data);
export const clearConversations = () => api.post("/conversations/clear").then((r) => r.data);
export const getConnections = () => api.get("/connections").then((r) => r.data);
export const connectChannel = (channel, payload) => api.post(`/connections/${channel}`, payload).then((r) => r.data);
export const disconnectChannel = (channel) => api.delete(`/connections/${channel}`).then((r) => r.data);
export const oauthStartUrl = (provider) => `${API}/oauth/${provider}/start`;
export const saveOauthSession = (provider, payload) => api.post(`/oauth/${provider}/session`, payload).then((r) => r.data);
export const getWebhookInfo = () => api.get("/webhooks/meta/info").then((r) => r.data);
export const simulateInbound = (payload) => api.post("/webhooks/meta/simulate", payload).then((r) => r.data);
export const getKbEntries = () => api.get("/knowledge").then((r) => r.data.items);
export const getScheduleSlots = () => api.get("/schedule/slots").then((r) => r.data.slots);
export const saveScheduleSlots = (slots) => api.put("/schedule/slots", { slots }).then((r) => r.data.slots);
export const getAppointments = () => api.get("/appointments").then((r) => r.data.items);
export const updateAppointment = (id, payload) => api.patch(`/appointments/${id}`, payload).then((r) => r.data);
export const getMetrics = (range) => api.get("/metrics", { params: range ? { range } : {} }).then((r) => r.data);
export const getRgpdSettings = () => api.get("/settings/rgpd").then((r) => r.data);
export const saveRgpdSettings = (payload) => api.put("/settings/rgpd", payload).then((r) => r.data);
export const createKbEntry = (formData) => api.post("/knowledge", formData).then((r) => r.data);
export const updateKbEntry = (id, formData) => api.put(`/knowledge/${id}`, formData).then((r) => r.data);
export const toggleKbEntry = (id) => api.patch(`/knowledge/${id}/toggle`).then((r) => r.data);
export const deleteKbEntry = (id) => api.delete(`/knowledge/${id}`).then((r) => r.data);
export const kbFileUrl = (id) => `${API}/knowledge/${id}/file`;
export const getClinic = () => api.get("/clinic").then((r) => r.data);
export const saveClinic = (payload) => api.put("/settings/clinic", payload).then((r) => r.data);
export const getBotMessages = () => api.get("/settings/bot-messages").then((r) => r.data);
export const saveBotMessages = (payload) => api.put("/settings/bot-messages", payload).then((r) => r.data);
export const getTeam = () => api.get("/team").then((r) => r.data.items);
export const inviteMember = (payload) => api.post("/team/invite", payload).then((r) => r.data);
export const updateMember = (id, payload) => api.patch(`/team/${id}`, payload).then((r) => r.data);
export const getInvitation = (token) => api.get(`/invitations/${token}`).then((r) => r.data);
export const acceptInvitation = (token, payload) => api.post(`/invitations/${token}/accept`, payload).then((r) => r.data);
export const inviteLink = (token) => `${window.location.origin}/invitacion?token=${token}`;
export const getBotStatus = () => api.get("/bot/status").then((r) => r.data);
export const setBotStatus = (enabled) => api.put("/bot/status", { enabled }).then((r) => r.data);
export const takeoverConversation = (id) => api.post(`/conversations/${id}/takeover`).then((r) => r.data);
export const releaseConversation = (id) => api.post(`/conversations/${id}/release`).then((r) => r.data);
export const sendManualMessage = (id, text) => api.post(`/conversations/${id}/messages`, { text }).then((r) => r.data);
export const getAutoReplies = () => api.get("/auto-replies").then((r) => r.data.items);
export const createAutoReply = (payload) => api.post("/auto-replies", payload).then((r) => r.data);
export const updateAutoReply = (id, payload) => api.put(`/auto-replies/${id}`, payload).then((r) => r.data);
export const deleteAutoReply = (id) => api.delete(`/auto-replies/${id}`).then((r) => r.data);
export const changePassword = (payload) => api.post("/auth/change-password", payload).then((r) => r.data);
export const rereadKbEntry = (id) => api.post(`/knowledge/${id}/reread`, null, { timeout: 120000 }).then((r) => r.data);
export const getTrainingNotes = () => api.get("/training/notes").then((r) => r.data);
export const createTrainingNote = (payload) => api.post("/training/notes", payload).then((r) => r.data);
export const updateTrainingNote = (id, payload) => api.put(`/training/notes/${id}`, payload).then((r) => r.data);
export const deleteTrainingNote = (id) => api.delete(`/training/notes/${id}`).then((r) => r.data);
export const getTrainingSites = () => api.get("/training/sites").then((r) => r.data.items);
export const addTrainingSite = (payload) => api.post("/training/sites", payload, { timeout: 180000 }).then((r) => r.data);
export const refreshTrainingSite = (id) => api.post(`/training/sites/${id}/refresh`, null, { timeout: 180000 }).then((r) => r.data);
export const deleteTrainingSite = (id) => api.delete(`/training/sites/${id}`).then((r) => r.data);
export const testAssistant = (payload) => api.post("/training/test", payload, { timeout: 90000 }).then((r) => r.data);
export const addTrainingSitesBulk = (payload) => api.post("/training/sites/bulk", payload).then((r) => r.data);
